
import { defineComponent, onMounted } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import Overview from "@/views/resources/documentation/base/rotate/Overview.vue";
import Basic from "@/views/resources/documentation/base/rotate/Basic.vue";
import Toggle from "@/views/resources/documentation/base/rotate/Toggle.vue";

export default defineComponent({
  name: "indicator",
  components: {
    Overview,
    Basic,
    Toggle
  },
  setup() {
    onMounted(() => {
      setCurrentPageTitle("Rotate");
    });
  }
});
